import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import {useIsVerboseLocale} from '@app/hooks/use-verbose-locale';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

const IMAGE_CONFIG: LocalImageConfig = {
	default: '82b9d8345b387738b7509a3d6f98a567.png',
	fr: 'e890d66a7c3ed948cbd54aacad6b4505.png',
};

export const Cheating: FunctionComponent = () => {
	const {t} = useTranslation();
	const src = useLocalImage(IMAGE_CONFIG);
	const isVerboseLocale = useIsVerboseLocale();

	const fontSize = isVerboseLocale
		? {base: 'xs', sm: 'sm', xl: 'md'}
		: undefined;
	return (
		<LandingIllustrationSection
			imagePosition="left"
			description={
				<>
					<LandingHeading as="h2">
						{t('musicquizlandingpage_title_nocheatingallowed_standalone-web', {
							ns: 'musicquiz',
						})}
					</LandingHeading>
					<LandingParagraph>
						{t('musicquizlandingpage_text_nocheatingallowed_standalone-web', {
							ns: 'musicquiz',
						})}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					aspectRatio="1440/840"
					sizes={{base: '100vw', md: '50vw'}}
					src={src}
					alt={t('generic_action_playnow_standalone-web', {ns: 'common'})}
				/>
			}
			cta={
				<LandingButtonLink
					href="https://link.deezer.com/?dest=https%3A%2F%2Fwww.deezer.com%2Fchannels%2Fgames%3Fbypassreferer%3D1&amv=8.0.12&imv=10.12.0"
					tracking={{
						eventaction: 'discover-channel-game',
						eventlabel: 'section5',
					}}
					fontSize={fontSize}
				>
					{t('generic_action_seehow_standalone-web', {ns: 'common'})}
				</LandingButtonLink>
			}
		/>
	);
};
